import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaGraduationCap, FaCalendarAlt, FaMapMarkerAlt, FaAward } from 'react-icons/fa';
import { useLanguage } from '../utils/LanguageContext';
import './AllComponents.css';

const Education = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });

  const { t } = useLanguage();

  const education = [
    {
      degree: t('education.educationData.masters.degree'),
      university: t('education.educationData.masters.university'),
      location: t('education.educationData.masters.location'),
      period: "Oct 2022 - Apr 2025",
      focus: t('education.educationData.masters.focus'),
      description: t('education.educationData.masters.description'),
      courses: t('education.educationData.masters.courses')
    },
    {
      degree: t('education.educationData.bachelors.degree'),
      university: t('education.educationData.bachelors.university'), 
      location: t('education.educationData.bachelors.location'),
      period: "Apr 2019 - Sep 2022",
      focus: t('education.educationData.bachelors.focus'),
      description: t('education.educationData.bachelors.description'),
      courses: t('education.educationData.bachelors.courses')
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <section id="education" className="section education-section">
      <div className="container">
        <motion.div
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <motion.div variants={itemVariants} className="section-header text-center">
            <h2 className="gradient-text">{t('education.title')}</h2>
            <p className="section-subtitle">
              {t('education.academicBackground')}
            </p>
          </motion.div>

          <div className="education-grid">
            {education.map((edu, index) => (
              <motion.div
                key={index}
                className="education-card card"
                variants={itemVariants}
                whileHover={{ scale: 1.02 }}
              >
                <div className="education-header">
                  <div className="degree-icon">
                    <FaGraduationCap />
                  </div>
                  <div className="degree-info">
                    <h3>{edu.degree}</h3>
                    <h4>{edu.university}</h4>
                  </div>
                  <div className="focus-badge">
                    <FaAward />
                    <span>{t('education.focus')}: {edu.focus}</span>
                  </div>
                </div>

                <div className="education-meta">
                  <div className="meta-item">
                    <FaCalendarAlt />
                    <span>{edu.period}</span>
                  </div>
                  <div className="meta-item">
                    <FaMapMarkerAlt />
                    <span>{edu.location}</span>
                  </div>
                </div>

                <p className="education-description">{edu.description}</p>

                <div className="courses-section">
                  <h5>{t('education.keyCourses')}:</h5>
                  <div className="courses-list">
                    {edu.courses.map((course, courseIndex) => (
                      <span key={courseIndex} className="course-tag">
                        {course}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Education; 